import script from "./AboutTeamComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./AboutTeamComponent.vue?vue&type=script&setup=true&lang=js"

import "./AboutTeamComponent.vue?vue&type=style&index=0&id=34220924&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34220924"]])

export default __exports__